import { render } from "./Loader.vue?vue&type=template&id=6bf88a98"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=6bf88a98&lang=css"
script.render = render

export default script